export default __webpack_public_path__ + "static/media/level_5.77ab0d9b.jpg";